import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export interface CanComponentDeactivate {
    canDeactivate: (params?: any) => boolean;
}

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard {
    canDeactivate(
        component: CanComponentDeactivate,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): boolean {
        if (nextState.url.includes('logout') || !component) {
            return true;
        }
        return component.canDeactivate ? component.canDeactivate(nextState) : true;
    }
}
